export default __webpack_public_path__ + "static/media/mobile_logo2.ffb5d394.png";